export default [
  {
    _name: 'CSidebarNav',
    _children: [
      {
        _name: 'CSidebarNavItem',
        name: 'Dashboard',
        to: 'Dashboard',
        icon: {
          src: require('@/assets/img/element-4.png'),
          width: 15,
          height: 15,
          class: 'mr-3'
        },
      },
      {
        _name: 'CSidebarNavItem',
        name: 'Kemas Data',
        to: 'UpdateData',
        icon: {
          src: require('@/assets/image/icon/icon-noti.png'),
          width: 15,
          height: 15,
          class: 'mr-3'
        },
      },
      {
        _name: 'CSidebarNavItem',
        name: 'Pengurusan Pengguna',
        to: 'UserManagement',
        icon: {
          src: require('@/assets/image/icon/icon-user.png'),
          width: 15,
          height: 15,
          class: 'mr-3'
        },
      },
      {
        _name: 'CSidebarNavDropdown',
        name: 'Laporan',
        icon: {
          src: require('@/assets/image/laporan.png'),
          width: 15,
          height: 15,
          class: 'mr-3',
        },
        items: [
          {
            name: 'By Unit',
            to: '',
            icon: {
              src: require('@/assets/image/list.png'),
              width: 15,
              height: 15,
              class: 'mr-3',
            },
          },
          {
            name: 'By Pusat',
            to: '',
            icon: {
              src: require('@/assets/image/list.png'),
              width: 15,
              height: 15,
              class: 'mr-3',
            },
          },
          {
            _name: 'CSidebarNavDropdown',
            name: 'By Status',
            icon: {
              src: require('@/assets/image/list.png'),
              width: 15,
              height: 15,
              class: 'mr-3',
            },
            items: [
              {
                name: 'Selesai',
                to: '',
                icon: {
                  src: require('@/assets/image/list.png'),
                  width: 15,
                  height: 15,
                  class: 'mr-3',
                },
              },
              {
                name: 'KIV',
                to: '',
                icon: {
                  src: require('@/assets/image/list.png'),
                  width: 15,
                  height: 15,
                  class: 'mr-3',
                },
              },
              {
                name: 'Delay',
                to: '',
                icon: {
                  src: require('@/assets/image/list.png'),
                  width: 15,
                  height: 15,
                  class: 'mr-3',
                },
              },
            ],
          },
        ],
      }
      
     
     
     
     
      
     
    ]
  },
  {
    _name: 'CSidebarNav',
    _children: [
      {
        _name: 'CSidebarNavItem',
        name: 'Setting',
        to: 'Setting',
      },
      {
        _name: 'CSidebarNavItem',
        name: 'Logout',
        to: 'Logout',
      },
    ],
    _style: 'margin-top: auto;', // Pushes the navigation items to the bottom of the sidebar
  }
]